/**
 * Will search target for a parent collapsable. If found, 
 * will trigger collapsable to be open by updating the 
 * "data-collapsible-open" attribute to true, and 
 * listening for the target to appear before jumping to 
 * target.
 * 
 * @author Mark Nelson
 */

 import $ from "jquery";
 import debug from "debug";
 const log = debug("disclaimer");
 
 //
 // Config
 // ===========
 const DISCLAIMER_SELECTOR = "[data-disclaimer]";

const waitForElm = function(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};


const goToTarget = function (event, collapsable, target) {
    console.log(event, collapsable, target);
    event.preventDefault();
    $(collapsable).attr("data-collapsible-open","true");

    waitForElm(target).then(() => {
        window.location.href = target;
    });
};

 function init (){
     const disclaimerElements = $(DISCLAIMER_SELECTOR);
     log(disclaimerElements);
     disclaimerElements.each(function(index, element){

        var target = $(element).attr("href");
        var collapsable = $(target).closest("[data-collapsible]");

        if(collapsable) {
            $(element).on('click', function(event) {
                goToTarget(event, collapsable, target);
             });
        } else{
            window.location.href = target;
        };
     });
 
 };
 
 init();
 
 


// WEBPACK FOOTER //
// ./project/client/src/core/components/disclaimer/index.js